import { render, staticRenderFns } from "./PageAvatar.vue?vue&type=template&id=74be3458&scoped=true"
import script from "./PageAvatar.vue?vue&type=script&lang=js"
export * from "./PageAvatar.vue?vue&type=script&lang=js"
import style0 from "./PageAvatar.vue?vue&type=style&index=0&id=74be3458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be3458",
  null
  
)

export default component.exports